const pendingWishlistCols = ['ean', 'title', 'serie', 'publisher', 'fullPrice', 'quantity'];

export default pendingWishlistCols;
